export const sharedConfig = {
  transitions: false,
  pannable: false,
  zoomable: false
};
